import {tagList} from "../../../utils/Constants";

// Central config for the recipient filter panel. Adding a filter is a localized
// change here plus a control in RecipientBuilder.
export const DEFAULT_CRITERIA = {
    country: null,
    customer_status: [],
    tags: [],
    subscription_types: [],
    last_login_within_months: null,
    last_login_from: null,
    last_login_to: null,
    signed_up_within_months: null,
    signed_up_from: null,
    signed_up_to: null,
    include_sub_profiles: false,
};

export const COUNTRY_OPTIONS = [
    {label: 'email_campaign.country_all', value: null},
    {label: 'email_campaign.country_tr', value: 'tr'},
    {label: 'email_campaign.country_foreign', value: 'foreign'},
];

export const CUSTOMER_STATUS_OPTIONS = [
    {label: 'email_campaign.status_musteri', value: 'musteri'},
    {label: 'email_campaign.status_eski', value: 'eski_musteri'},
    {label: 'email_campaign.status_potansiyel', value: 'potansiyel'},
    {label: 'email_campaign.status_diger', value: 'diger'},
];

export const SUBSCRIPTION_TYPE_OPTIONS = [
    {label: 'Basic', value: 'basic'},
    {label: 'Professional', value: 'professional'},
    {label: 'Premium', value: 'premium'},
    {label: 'Trial', value: 'trial'},
    {label: 'Shopify', value: 'shopify'},
];

export const TAG_OPTIONS = tagList.map((t) => ({label: t, value: t}));

// value = months; special 'custom' reveals date pickers, null = any.
export const DATE_QUICK_OPTIONS = [
    {label: 'email_campaign.date_any', value: 'any'},
    {label: 'email_campaign.date_3m', value: 3},
    {label: 'email_campaign.date_6m', value: 6},
    {label: 'email_campaign.date_12m', value: 12},
    {label: 'email_campaign.date_24m', value: 24},
    {label: 'email_campaign.date_custom', value: 'custom'},
];
